module.exports = __webpack_public_path__ + "img/背景.3161d9fd.jpg";